<template>
  <div class="invoice-info" v-loading="isLoading">
    <el-row class="margin-b-10">
      <el-col :span="4">待审核金额：{{ paymentOrder.unaudittedAmount }}</el-col>
      <el-col :span="4">已开票金额：{{ paymentOrder.amountWithInvoices }}</el-col>
      <el-col :span="4">待开票金额：{{ paymentOrder.amountWithoutInvoices }}</el-col>
      <el-col :span="12" style="text-align: right">
        <el-button
          type="primary"
          @click="showAddInvoice"
          :disabled="!invoiceEnable || !selectedRows.length"
          >录入发票
        </el-button>
      </el-col>
    </el-row>
    <el-table
      :data="paymentOrderList"
      ref="paymentOrderTable"
      @selection-change="onPaymentOrderSelectionChange"
      v-loading="downloading"
    >
      <el-table-column
        type="selection"
        width="45"
        :selectable="
          (row, index) =>
            invoiceEnable && ['待录入发票', '未验票已付款'].includes(row.payOrderStatus)
        "
      />
      <el-table-column prop="payOrderId" label="付款单号" width="170" />
      <el-table-column prop="supplier" label="供应商名称" />
      <el-table-column prop="invoiceHeader" label="发票抬头" />
      <el-table-column prop="invoiceType" label="发票类型" width="120" />
      <el-table-column prop="amountWithTax" label="开票含税金额" width="100" />
      <el-table-column prop="taxRate" label="税率" width="60" />
      <el-table-column prop="payOrderStatus" label="付款单状态" width="100" />
      <el-table-column prop="invoiceSubmitted" label="是否已录入发票" width="110" />
      <el-table-column prop="createdTime" label="生成时间" width="140" />
      <el-table-column label="下载付款单" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="downloadPayOrder(scope.row.payOrderId)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="billInfo" style="margin-top: 20px">
      <el-row>
        <el-col :span="18"
          >已录入发票<span style="color: red"
            >（*重要：发票录入完成后，请勿忘记点击“提交发票”按钮，否则影响支付进度）</span
          ></el-col
        >
        <el-col :span="6" style="text-align: right">
          <el-button type="primary" @click="getAddedInvoices">刷新验票状态 </el-button>
          <el-button
            type="primary"
            :disabled="!(addedInvoices || []).length"
            @click="downloadInvoices"
            >下载发票</el-button
          >
        </el-col>
      </el-row>
      <el-row class="margin-b-10" style="color: red">
        <el-col :span="4">发票数量：{{ passedCount || '-' }}</el-col>
        <el-col :span="6">发票含税总额：{{ passedTotalTaxAmount || '-' }}</el-col>
      </el-row>
    </div>
    <!--    <el-table stripe :data="invoiceList">-->
    <el-table stripe :data="addedInvoices">
      <el-table-column prop="invoiceDate" fixed label="开票日期" width="100" />
      <el-table-column prop="invoiceCode" label="发票代码" width="110">
        <template slot-scope="{ row }">
          <span>{{
            row.invoiceTypeCode === INVOICE_TYPE.OTHER_REIMBURSABLE ? '' : row.invoiceCode
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="invoiceNo" label="发票编号">
        <template slot-scope="{ row }">
          <span>{{
            row.invoiceTypeCode === INVOICE_TYPE.OTHER_REIMBURSABLE ? '' : row.invoiceNo
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="verifyCode" label="校验码后6位" width="100" />
      <el-table-column prop="untaxedAmount" label="未税金额" width="100" />
      <el-table-column prop="taxRate" label="税率(%)" width="70" />
      <el-table-column prop="tax" label="税额" width="100" />
      <el-table-column prop="amount" label="含税金额" width="100" />
      <el-table-column prop="checkStatus" label="验票状态" width="120" />
      <el-table-column prop="errorMessage" label="错误信息" width="150" />
      <el-table-column prop="invoiceHeader" label="发票抬头" min-width="150" />
      <el-table-column prop="invoiceType" label="发票类型" width="120" />
      <el-table-column label="关联付款单" width="180">
        <template slot-scope="scope">
          <div v-for="item in scope.row.payOrders.split(',')" :key="item">{{ item }}</div>
        </template>
      </el-table-column>
      <el-table-column label="附件">
        <template slot-scope="scope">
          <a v-if="scope.row.url" :href="scope.row.url" target="_blank">查看 </a>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="false"
            @click="checkInvoice(scope.row)"
            :loading="isLoading"
            >验证发票
          </el-button>
          <el-button
            type="text"
            :disabled="!invoiceEnable"
            @click="deleteInvoice(scope.row)"
            :loading="isLoading"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="align-r margin-t-10">
      <el-button
        type="primary"
        :disabled="!addedInvoices.length"
        @click="submitInvoice"
        :loading="isLoading"
        >提交发票
      </el-button>
    </el-row>
    <el-dialog
      title="录入发票"
      :visible.sync="invoiceDialogVisible"
      :modal="isModalShow"
      width="75%"
      destroy-on-close
    >
      <InvoiceEnter
        :tax-rate="selectedRows[0] ? selectedRows[0].taxRate : null"
        :pay-order-amount-list="selectedRows.map(item => item.amountWithTax)"
        :pay-order-id-list="selectedRows.map(item => item.payOrderId)"
        :added-invoice-no-list="addedInvoices.map(item => item.invoiceNo)"
        :serverCheckErrors="serverCheckErrors"
        @confirm="saveInvoice"
      />
      <div slot="footer">
        <el-button @click="invoiceDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="75%"
      title="结算系统付款单申请要求"
      :modal="isModalShow"
      :visible.sync="paymentNoticeDialogVisible"
    >
      <iframe
        src="https://fe-config.meituan.com/bm/config/bike-web/24bif1gfi73f599i3h.html"
        style="border: 0; height: 50vh; width: 100%"
      ></iframe>
      <div slot="footer">
        <el-button @click="paymentNoticeDialogVisible = false">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import InvoiceEnter from '@/components/InvoiceEnter/index.vue'
import { INVOICE_TYPE } from '@/components/InvoiceEnter/default'

export default {
  components: { InvoiceEnter },
  props: {
    invoiceEnable: {
      type: Boolean,
      default: false,
    },
    // 是否展示弹窗蒙层
    isModalShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      INVOICE_TYPE,
      passedTotalTaxAmount: 0,
      passedCount: 0,
      orderId: '',
      serverCheckErrors: '',
      addedInvoices: [],
      pendingInvoice: [], // 待提交发票
      invoiceList: [],
      tempInvoiceList: [],
      paymentOrder: {},
      paymentOrderList: [],
      isLoading: false,
      invoiceDialogVisible: false,
      paymentNoticeDialogVisible: false,
      selectedRows: [],
      downloading: false,
    }
  },
  mounted() {
    this.$debugVue('v_invoiceInfo', this)
  },
  computed: {
    payOrderIds() {
      return this.selectedRows.reduce((curSum, cur) => {
        curSum.push(cur.payOrderId)
        return curSum
      }, [])
    },
    // 已选付款单含税金额总和
    selectedRowsAmount() {
      return this.selectedRows.reduce((acc, cur) => acc + +cur.amountWithTax, 0)
    },
    // 已录入发票含税金额总和
    tempInvoiceAmount() {
      return this.tempInvoiceList.reduce((acc, cur) => acc + cur.amount, 0)
    },
    // 已选择付款单ids
    selectedRowsIds() {
      return this.selectedRows.reduce((acc, cur) => {
        acc.push(cur.payOrderId)
        return acc
      }, [])
    },
  },

  methods: {
    async deleteInvoice({ invoiceNo }) {
      this.$confirm('确认删除该发票？', '提示', {
        type: 'warning',
      })
        .then(async () => {
          try {
            const params = {
              invoiceNo,
            }
            const res = await this.fetch.get('reconcileBill_deleteInvoiceHella', { params })
            this.$message.success(res.message)
            this.getAddedInvoices()
          } catch (e) {
            console.log('删除异常', e)
          }
        })
        .catch(() => {})
    },
    async checkInvoice(row) {
      try {
        // 填坑：后端这个接口发票抬头 是 invoiceBody
        row.invoiceBody = row.invoiceHeader

        const data = {
          orderId: this.orderId,
          payOrderIds: row.payOrders, // 英文逗号分隔的付款单ID列表
          invoices: [row],
        }
        const res = await this.fetch.post('reconcileBill_checkInvoice', data)
        this.$message.success(res.message)
        this.getAddedInvoices()
      } catch (e) {
        console.log('验证异常', e)
      }
    },
    initFetch(params) {
      this.orderId = params.orderId
      // this.getInvoiceList()
      this.getAddedInvoices()
      this.getPaymentOrderList()
    },
    // 付款单信息
    getPaymentOrderList() {
      const params = {
        orderNo: this.orderId,
      }
      this.isLoading = true
      this.fetch
        .get('settlementGetPayOrdersHella', { params })
        .then(res => {
          this.isLoading = false
          this.paymentOrder = res.data || {}
          this.paymentOrderList = this.paymentOrder.invoiceList || []
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    // 发票信息
    // getInvoiceList() {
    getAddedInvoices() {
      const params = {
        orderNo: this.orderId,
      }
      this.isLoading = true
      this.fetch
        .get('settlementGetInvoiceHella', { params })
        .then(res => {
          this.isLoading = false
          const { invoiceList, passedCount, passedTotalTaxAmount } = res.data || {}
          this.addedInvoices = invoiceList || []
          this.passedCount = passedCount
          this.passedTotalTaxAmount = passedTotalTaxAmount
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    async addInvoice() {
      try {
        // 需要验证录入的多张发票的含税金额汇总=勾选的付款单含税金额之和（误差允许1元以内）
        // 否则报错“发票金额与付款单金额不匹配”
        // if (Math.abs(this.sumWithTaxTotal - this.selectedRowsTotal) > 1) {
        //   return this.$message.error('发票金额与付款单金额不匹配')
        // }

        const data = {
          invoices: this.pendingInvoice,
          payOrder: this.payOrderIds.join(','),
        }
        const res = await this.fetch.post('reconcileBill_confirmInvoiceHella', data)
        if (res.message === 'success') {
          this.$message.success(res.message)
          this.invoiceDialogVisible = false
          this.getAddedInvoices()
        } else {
          // 异常时回显在录入弹框
          this.serverCheckErrors =
            Math.random()
              .toString()
              .slice(0, 9) + res.message
        }
      } catch (e) {
        console.log('addInvoice异常', e)
      }
    },
    // 展示录入发票弹框
    showAddInvoice() {
      // 不同法人名称、不同税率、不同发票类型不允许同时勾选开票
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (i === 0) continue
        if (
          this.selectedRows[i].invoiceHeader !== this.selectedRows[i - 1].invoiceHeader ||
          this.selectedRows[i].taxRate !== this.selectedRows[i - 1].taxRate ||
          this.selectedRows[i].invoiceType !== this.selectedRows[i - 1].invoiceType
        ) {
          return this.$message.error('不同法人名称、不同税率、不同发票类型不允许同时勾选开票')
        }
      }
      this.serverCheckErrors = ''
      this.invoiceDialogVisible = true
      this.paymentNoticeDialogVisible = true
    },
    // 保存录入的发票
    saveInvoice(invoiceList) {
      this.pendingInvoice = invoiceList
      this.addInvoice()
    },
    // 选择付款单
    onPaymentOrderSelectionChange(val) {
      this.selectedRows = val
    },
    async submitInvoice() {
      // try {
      //
      // } catch (e) {
      //   console.log(e)
      // }
      // 发票状态校验
      if (this.addedInvoices.some(row => !['验票通过', '自动验票通过'].includes(row.checkStatus))) {
        this.$message.error(
          '有发票验证未通过不允许提交。重试「验证发票」操作，或「删除」发票后重新录入'
        )
        return
      }

      // // 发票类型和发票抬头校验
      // // a
      // const hasIncorrectInvoiceType = this.addedInvoices.some((row) => {
      //   let payOrderInvoiceType = null
      //   if (['0', '3', '31'].includes(row.invoiceType)) {
      //     payOrderInvoiceType = '增值税专用发票'
      //   } else {
      //     payOrderInvoiceType = '增值税普通发票'
      //   }
      //   const payOrders = row.payOrders.split(',')
      //   return payOrders.some((id) => {
      //     const payOrder = this.paymentOrderList.find((item) => item.payOrderId === id)
      //     return payOrder.invoiceType !== payOrderInvoiceType
      //   })
      // })
      // if (hasIncorrectInvoiceType) {
      //   this.$message.error('发票类型与付款单不一致，不允许提交')
      //   return
      // }
      // // b
      // const hasMissingFile = this.addedInvoices.some((row) => {
      //   return ['2', '3', '31', '32'].includes(row.invoiceType) && !row.url
      // })
      // if (hasMissingFile) {
      //   this.$message.error('该发票为电子发票但缺少附件，请删除发票后重新上传发票')
      //   return
      // }
      //
      // // 发票金额校验
      // const filteredPayOrderList = this.paymentOrderList
      //     .filter((row) => {
      //       return ['待录入发票', '未验票已付款'].includes(row.payOrderStatus)
      //     })
      // // a. 录入发票总金额和付款单金额校验
      // const payOrderAmount = filteredPayOrderList
      //     .map((row) => {
      //       return row.amountWithTax
      //     })
      //     .reduce(computeAdd, 0)
      // const invoiceAmount = this.addedInvoices
      //     .map((row) => {
      //       return row.amount
      //     })
      //     .reduce(computeAdd, 0)
      // if (Math.abs(payOrderAmount - invoiceAmount) > 1) {
      //   this.$message.error('发票总金额与付款单总金额不一致，不允许提交')
      //   return
      // }
      // // b. “待录入发票”付款单必须有对应发票校验
      // const invoicePayOrderIds = this.addedInvoices
      //     .reduce((arr, row) => {
      //       return [...arr, ...row.payOrders.split(',')]
      //     }, [])
      // const payOrderIds = filteredPayOrderList
      //     .map((row) => {
      //       return row.payOrderId
      //     })
      // if (payOrderIds.some((id) => !invoicePayOrderIds.includes(id))) {
      //   this.$message.error('有付款单没录入发票，不允许提交')
      //   return
      // }
      // // c. 单张付款单与已录入发票金额校验
      // for (const payOrder of filteredPayOrderList) {
      //   const invoiceAmount = this.addedInvoices
      //       .filter((row) => {
      //         return row.payOrders.split(',').includes(payOrder.payOrderId)
      //       })
      //       .map((row) => {
      //         return row.amount
      //       })
      //       .reduce(computeAdd, 0)
      //   if (payOrder.amountWithTax - invoiceAmount > 1) {
      //     this.$message.error(`付款单${payOrder.payOrderId}发票金额不足，不允许提交，请重新检查发票信息`)
      //     return
      //   }
      // }

      try {
        const params = {
          orderNo: this.orderId,
        }
        await this.fetch.get('reconcileBill_submitInvoiceHella', { params })
        this.$message.success('发票提交成功，纸质发票请尽快邮寄')
        this.getPaymentOrderList()
        this.getAddedInvoices()
      } catch (e) {
        console.log('提交发票异常', e)
      }
    },
    // 下载付款单
    downloadPayOrder(orderNo) {
      const params = {
        orderNo,
      }
      this.downloading = true
      this.fetch
        .get('settlementDownloadPayOrder', { params })
        .then(res => {
          this.downloading = false
          if (res.data) {
            window.open(res.data)
          }
        })
        .catch(() => {
          this.downloading = false
        })
    },
    downloadInvoices() {
      const idList = this.addedInvoices.map(item => item.id)
      const params = {
        idListString: idList.join(),
      }
      this.downloading = true
      this.fetch
        .get('settlementDownloadInvoice', { params })
        .then(res => {
          this.downloading = false
          if (res.data) {
            window.downloadFile(res.data)
          }
        })
        .catch(() => {
          this.downloading = false
        })
    },
  },
}
</script>
<style scoped lang="scss">
.billInfo {
  font-size: 14px;

  .el-row {
    margin-bottom: 10px;
  }
}
</style>
